import { createFrontendPlugin, FrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api'
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha'

import { rootRouteRef } from './routes';

const observabilityMetricsPage = PageBlueprint.make({
  name: 'ObservabilityMetricsPage',
  params: {
    path: '/observability-metrics',
    title: 'Observability',
    routeRef: rootRouteRef,
    loader: () => import('./components/PrometheusMetricsComponent').then(m => <m.PrometheusMetricsTable />)
  },
})

const observabilityEntityPage = EntityContentBlueprint.make({
  name: 'ObservabilityMetricsEntityPage',
  params: {
    path: 'observability-metrics',
    title: 'Observability',
    filter: (entity) => entity.kind === 'Component' && entity.spec?.type === 'service',
    loader: () => import('./components/PrometheusMetricsComponent').then(m => <m.PrometheusMetricsTable />)
  },
})

const observabilityMetricsPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'observability-metrics',
  routes: {
    root: rootRouteRef,
  },
  extensions: [observabilityMetricsPage, observabilityEntityPage]
})

export default observabilityMetricsPlugin
